import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useRackTemplateTypes = () => {
  const templateRacks = useSelector(
    (state: RootState) => state.availableRacks.available
  );
  const templateTypesStrings: string[] = [];
  const templateTypes: any = [];
  const t = new Set(
    templateRacks.map((r) => {
      templateTypes.push(r.rack_type);
      return `${r.rack_type[1]}x${r.rack_type[0]}`;
    })
  );

  t.forEach((item) => templateTypesStrings.push(item));

  return {
    templateTypesStrings,
    templateTypes: templateTypes as [number, number][],
  };
};
